<div class="blockUI" style="display:none">
</div>
<div class="blockUI blockOverlay top-element"
   >
</div>
<div class="blockUI blockMsg blockElement bottom-element"
    >
    <div class="sk-fold sk-primary">
        <div class="sk-fold-cube"></div>
        <div class="sk-fold-cube"></div>
        <div class="sk-fold-cube"></div>
        <div class="sk-fold-cube"></div>
    </div>
    <h5>{{'Loading' | translate}}...</h5>
</div>